export enum FontStyle {
  Normal = 'normal',
  Bold = 'bold',
}

export interface FontOptions<TFontSize, TFontColor> {
  fontSize: TFontSize;
  fontColor: TFontColor;
  fontFamily: string;
  fontStyle: FontStyle;
}

export class FontBuilder<TFontSize, TFontColor> {
  private fontSize: TFontSize;
  private fontColor: TFontColor;
  private fontFamily: string;
  private fontStyle: FontStyle;

  constructor(
    defaultFontSize: TFontSize,
    defaultFontColor: TFontColor,
    defaultFontFamily = 'DM Sans',
  ) {
    this.fontSize = defaultFontSize;
    this.fontColor = defaultFontColor;
    this.fontFamily = defaultFontFamily;
    this.fontStyle = FontStyle.Normal;
  }

  setFontSize(size: TFontSize): this {
    this.fontSize = size;
    return this;
  }

  setFontStyle(style: FontStyle): this {
    this.fontStyle = style;
    return this;
  }

  setFontColor(color: TFontColor): this {
    this.fontColor = color;
    return this;
  }

  build(): FontOptions<TFontSize, TFontColor> {
    return {
      fontSize: this.fontSize,
      fontColor: this.fontColor,
      fontFamily: this.fontFamily,
      fontStyle: this.fontStyle,
    };
  }

  static create<TFontSize, TFontColor>(
    defaultFontSize: TFontSize,
    defaultFontColor: TFontColor,
    defaultFontFamily = 'DM Sans',
  ) {
    return new FontBuilder<TFontSize, TFontColor>(
      defaultFontSize,
      defaultFontColor,
      defaultFontFamily,
    );
  }
}
